import { useEffect, useMemo, useState } from 'react'
import Chip from '../../ds/Chip.jsx'
import { watchSubmissions } from '../../lib/formsData.js'
import { submissionReviewState, submissionName } from '../../lib/formsView.js'

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'needs-review', label: 'Needs review' },
  { key: 'real', label: 'Real' },
  { key: 'spam', label: 'Spam' },
]

const STATE_CHIP = {
  'needs-review': { color: 'var(--color-danger, #d9534f)', label: 'Needs review' },
  released: { color: 'var(--color-gold)', label: 'Released' },
  kept: { color: 'var(--color-muted)', label: 'Spam (kept)' },
  real: { color: 'var(--color-gold)', label: 'Real' },
}

function matchesFilter(state, filter) {
  if (filter === 'all') return true
  if (filter === 'needs-review') return state === 'needs-review'
  if (filter === 'real') return state === 'real' || state === 'released'
  if (filter === 'spam') return state === 'needs-review' || state === 'kept'
  return true
}

function fmtDate(ts) {
  const d = ts && ts.toDate ? ts.toDate() : ts ? new Date(ts) : null
  return d ? d.toLocaleDateString() : '—'
}

export default function FormSubmissions({ formId, onOpenSubmission }) {
  const [subs, setSubs] = useState([])
  const [filter, setFilter] = useState('all')
  useEffect(() => watchSubmissions(formId, setSubs), [formId])

  const needsReview = useMemo(() => subs.filter((s) => submissionReviewState(s) === 'needs-review').length, [subs])
  const rows = subs.filter((s) => matchesFilter(submissionReviewState(s), filter))

  const th = { padding: '8px 12px', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--color-muted)', textAlign: 'left' }
  const cell = { padding: '10px 12px', fontSize: 13, color: 'var(--color-white)' }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} className="btn" style={{ fontSize: 12, padding: '6px 12px', background: f.key === filter ? 'var(--color-gold)' : 'transparent', color: f.key === filter ? 'var(--color-ink)' : 'var(--color-muted)', border: '1px solid var(--color-divider-dark)' }}>
            {f.label}{f.key === 'needs-review' && needsReview > 0 ? ` (${needsReview})` : ''}
          </button>
        ))}
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>Date</th><th style={th}>Name / email</th><th style={th}>Status</th></tr></thead>
          <tbody>
            {rows.map((s) => {
              const state = submissionReviewState(s)
              const chip = STATE_CHIP[state]
              return (
                <tr key={s.id} onClick={() => onOpenSubmission(s.id)} style={{ cursor: 'pointer', borderTop: '1px solid var(--color-divider-dark)', background: state === 'needs-review' ? 'rgba(217,83,79,.06)' : 'transparent' }}>
                  <td style={cell}>{fmtDate(s.createdAt)}</td>
                  <td style={cell}>{submissionName(s)}</td>
                  <td style={cell}><Chip variant="outline" color={chip.color} dot>{chip.label}</Chip></td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {rows.length === 0 && <div style={{ fontSize: 13, color: 'var(--color-muted)', padding: '16px 12px' }}>No submissions in this view.</div>}
      </div>
    </div>
  )
}
